import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './firebase';

import Login from './components/Login';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Cases from './pages/Cases';
import CaseDetails from './components/CaseDetails';
import Analyzer from './pages/Analyzer';
import AIParalegal from './pages/AIParalegal';
import ResearchVault from './pages/ResearchVault';
import VirtualCourt from './pages/VirtualCourt';
import Team from './pages/Team';
import MemberPerformance from './pages/MemberPerformance';
import Settings from './pages/Settings';
import CustomModels from './pages/CustomModels';
import CategoryDetails from './pages/CategoryDetails';
import Sequencer from './pages/Sequencer';
import Precedents from './pages/Precedents';
import ContractCompare from './pages/ContractCompare';
import TermsAndConditions from './pages/TermsAndConditions';
import './App.css';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1565c0',
      dark: '#0d47a1',
    },
    secondary: {
      main: '#f50057',
    },
    background: {
      default: '#f5f7fa',
      paper: '#ffffff',
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
  },
});

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setUser(user);
      setLoading(false);
    });

    return unsubscribe;
  }, []);

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  return (
    <ThemeProvider theme={theme}>
      <Router>
        <Routes>
          <Route path="/login" element={user ? <Navigate to="/" /> : <Login />} />
          <Route path="/terms" element={<TermsAndConditions />} />
          <Route
            path="/"
            element={user ? <Layout><Dashboard /></Layout> : <Navigate to="/login" />}
          />
          <Route
            path="/cases"
            element={user ? <Layout><Cases /></Layout> : <Navigate to="/login" />}
          />
          <Route
            path="/case/:id"
            element={user ? <Layout><CaseDetails /></Layout> : <Navigate to="/login" />}
          />
          <Route
            path="/analyzer"
            element={user ? <Layout><Analyzer /></Layout> : <Navigate to="/login" />}
          />
          <Route
            path="/ai-paralegal"
            element={user ? <Layout><AIParalegal /></Layout> : <Navigate to="/login" />}
          />
          <Route
            path="/research-vault"
            element={user ? <Layout><ResearchVault /></Layout> : <Navigate to="/login" />}
          />
          <Route
            path="/virtual-court"
            element={user ? <Layout><VirtualCourt /></Layout> : <Navigate to="/login" />}
          />
          <Route
            path="/team"
            element={user ? <Layout><Team /></Layout> : <Navigate to="/login" />}
          />
          <Route
            path="/team/:memberId/performance"
            element={user ? <Layout><MemberPerformance /></Layout> : <Navigate to="/login" />}
          />
          <Route
            path="/settings"
            element={user ? <Layout><Settings /></Layout> : <Navigate to="/login" />}
          />
          <Route
            path="/custom-models"
            element={user ? <Layout><CustomModels /></Layout> : <Navigate to="/login" />}
          />
          <Route
            path="/custom-models/:categoryId"
            element={user ? <Layout><CategoryDetails /></Layout> : <Navigate to="/login" />}
          />
          <Route
            path="/sequencer"
            element={user ? <Layout><Sequencer /></Layout> : <Navigate to="/login" />}
          />
          <Route
            path="/precedents"
            element={user ? <Layout><Precedents /></Layout> : <Navigate to="/login" />}
          />
          <Route
            path="/contract-compare"
            element={user ? <Layout><ContractCompare /></Layout> : <Navigate to="/login" />}
          />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
